import { cloneDeep } from "lodash";

export const tabsErrorsInit = (initialData = {}) => cloneDeep(initialData);

export const tabsErrorsReducer = (state, action) => {
  switch (action.type) {
    // case 'add': {
    //   const tabState = state[action.tab] || [];

    //   return {
    //     ...state,
    //     [action.tab]: [
    //       ...tabState,
    //       ...action.payload,
    //     ],
    //   };
    // }
    case "set": {
      return {
        ...state,
        [action.tab]: [...action.payload],
      };
    }
    case "reset": {
      const { [action.tab]: tabErrors, ...newState } = state;
      return newState || {};
    }
    case "init": {
      return tabsErrorsInit(action.payload);
    }
    default: {
      return state;
    }
  }
};
